import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export const Grid3x3Icon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
    >
      <path d="M8 20V16H4V14H8V10H4V8H8V4H10V8H14V4H16V8H20V10H16V14H20V16H16V20H14V16H10V20H8ZM10 14H14V10H10V14Z" />
    </SvgIcon>
  );
};
